import Image from "next/image";
import { useTranslation } from "react-i18next";
import time_diff from "@/assets/images/icons/time_diff.svg";
import { CircularDiv, InlineDiv } from "@/common/divs";
import { LightTextSpan, RegularText, SemiBoldText } from "@/common/texts";
import { AvailabilityHoursVm, ScheduleHoursRangeVm } from "@/model";
import {
  PRIMARY_BRAND_VARIANT_COLOR,
  PRIMARY_BUTTON_COLOR,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";
import { getMinuteDifference } from "@/utils/functions";

interface AvailableHoursProps {
  hoursAvailable: AvailabilityHoursVm;
  setSelectedHour: (hour: ScheduleHoursRangeVm) => void;
  selectedHour: ScheduleHoursRangeVm | undefined;
}

const AvailableHours: React.FC<AvailableHoursProps> = ({
  hoursAvailable,
  setSelectedHour,
  selectedHour,
}) => {
  const { t } = useTranslation();

  const getBackgroundColor = (hour: ScheduleHoursRangeVm): string => {
    if (selectedHour) {
      if (selectedHour.schedule && hour.schedule) {
        if (selectedHour.schedule.id == hour.schedule.id) {
          return PRIMARY_BRAND_VARIANT_COLOR;
        }
      }
    }
    return SECONDARY_BUTTON_COLOR;
  };

  const getBorderColor = (hour: ScheduleHoursRangeVm): string => {
    if (selectedHour) {
      if (selectedHour.schedule && hour.schedule) {
        if (selectedHour.schedule.id == hour.schedule.id) {
          return "1px solid " + PRIMARY_BUTTON_COLOR;
        }
      }
    }
    return "1px solid #E6E7E9";
  };

  return (
    <InlineDiv
      width="482px"
      paddingY="16px"
      style={{ paddingLeft: "15px" }}
      className="available-hours-container"
    >
      <SemiBoldText fontSize="18px" style={{ width: "100%" }}>
        {t("reservation.schedule_table.title")}
      </SemiBoldText>

      {hoursAvailable.scheduleHours.map((hour, index) => {
        return (
          <CircularDiv
            onClick={() => setSelectedHour(hour)}
            height="70px"
            paddingX="20px"
            width="145px"
            style={{
              backgroundColor: getBackgroundColor(hour),
              border: getBorderColor(hour),
              borderRadius: "12px",
              flexDirection: "column",
              cursor: "pointer",
            }}
            key={index}
          >
            {hour.start === hour.end ? null : (
              <InlineDiv
                style={{ gap: "8px", width: "100%", textAlign: "left" }}
              >
                <Image
                  src={time_diff}
                  width={16}
                  height={16}
                  alt={"time_diff" + index}
                  style={{ marginTop: "2.5px", width: "16px", height: "16px" }}
                />
                <LightTextSpan className="overflowOnTwoLines" fontSize="12px">
                  {hour.start &&
                    hour.end &&
                    getMinuteDifference(hour.start, hour.end) +
                      " " +
                      hour.headline}
                </LightTextSpan>
              </InlineDiv>
            )}

            {hour.start === hour.end ?
              <InlineDiv
                style={{ gap: "8px", width: "100%", textAlign: "left" }}
              >
                <Image
                  src={time_diff}
                  width={16}
                  height={16}
                  alt={"time_diff" + index}
                  style={{ marginTop: "4.5px", width: "16px", height: "16px" }}
                />{" "}
                {hour.headline ?
                  <RegularText>{hour.headline}</RegularText>
                : hour.start == "00:00" ?
                  <RegularText fontSize="12px">
                    Hora de inicio personalizada
                  </RegularText>
                : <RegularText>{hour.start}</RegularText>}
              </InlineDiv>
            : <RegularText>
                {hour.start} - {hour.end}
              </RegularText>
            }
          </CircularDiv>
        );
      })}
    </InlineDiv>
  );
};

export default AvailableHours;
